"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outerPad = exports.innerPad = void 0;
var innerPad = function (padding, minPadding) {
    var _a;
    if (minPadding === void 0) { minPadding = 0; }
    return Math.max(minPadding, typeof padding === 'number' ? padding : (_a = padding === null || padding === void 0 ? void 0 : padding.inner) !== null && _a !== void 0 ? _a : 0);
};
exports.innerPad = innerPad;
var outerPad = function (padding, minPadding) {
    var _a;
    if (minPadding === void 0) { minPadding = 0; }
    return Math.max(minPadding, typeof padding === 'number' ? padding : (_a = padding === null || padding === void 0 ? void 0 : padding.outer) !== null && _a !== void 0 ? _a : 0);
};
exports.outerPad = outerPad;
//# sourceMappingURL=dimensions.js.map